import React from 'react';
import {
  FIDELITE_SECTION_PROGRAMME,
  FIDELITE_SECTION_RECOMPENSES,
} from '../../utils/recompensePresentation';

/**
 * F2.2a — Sous-nav Fidélité : Mon programme | Récompenses
 * Pas de teaser pour les modules non livrés.
 */
export default function FideliteSectionNav({ activeSection, onSelect }) {
  const items = [
    { id: FIDELITE_SECTION_PROGRAMME, label: 'Mon programme' },
    { id: FIDELITE_SECTION_RECOMPENSES, label: 'Récompenses' },
  ];

  return (
    <nav
      className="flex flex-wrap gap-2 border-b border-gray-200 mb-6"
      aria-label="Sections fidélité"
      data-testid="fidelite-section-nav"
    >
      {items.map((item) => {
        const selected = activeSection === item.id;
        return (
          <button
            key={item.id}
            type="button"
            data-testid={`fidelite-section-${item.id}`}
            aria-current={selected ? 'page' : undefined}
            onClick={() => onSelect?.(item.id)}
            className={
              selected
                ? 'px-4 py-2 text-sm font-semibold text-[#4A148C] border-b-2 border-[#4A148C] -mb-px'
                : 'px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 border-b-2 border-transparent -mb-px'
            }
          >
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
